module.exports = __webpack_public_path__ + "static/img/H5-H5开发.8eab2e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10007/H5-H5开发.png
// module id = wWIc
// module chunks = 1